import { render, staticRenderFns } from "./VSelectRole.vue?vue&type=template&id=58dba3e4&scoped=true&"
import script from "./VSelectRole.vue?vue&type=script&lang=js&"
export * from "./VSelectRole.vue?vue&type=script&lang=js&"
import style0 from "./VSelectRole.vue?vue&type=style&index=0&id=58dba3e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dba3e4",
  null
  
)

export default component.exports